module.exports = __webpack_public_path__ + "img/Misi1-3-3Judul.ec069bc4.png";